$('.select-wrap select[name="wrap"]').on('change', function(e){
    this.form.submit();
});